import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const MacValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    const macRegex = /^([0-9a-f]{2}([:-]|$)){6}$|([0-9a-f]{4}([.]|$)){3}$/i;
    if (macRegex.test(value)) {
      return { valid: true };
    }

    return {
      valid: false,
      error: errorMessage,
    };
  };
};
